
import { MapTo } from '@adobe/aem-react-editable-components';
import MitekDesktopUpdater, { MitekDesktopUpdaterEditConfig } from './MitekDesktopUpdater';

export default MapTo('cob-corp-acquisition/components/creditonebank/mitek-desktop-updater')(MitekDesktopUpdater, MitekDesktopUpdaterEditConfig);
        